// Components
import Icon from '@/components/base/Icon';
import Select from '@/components/base/Select';
import ActionTag from '@/components/base/Tag/ActionTag';
import SelectFilter from '@/components/base/SelectFilter';

const ButtonSelectItems = ({
    placeholder,
    error,
    disabled,
    selected,
    style = 'grayBackground'
}) => {
    return (
        <Select.Button selected={selected} disabled={disabled} error={error} baseStyle={style}>
            <div className="flex items-center space-x-3">
                <span className="block truncate text-icoGray-400 dark:text-icoDarkMode-wolf">
                    {placeholder}
                </span>
            </div>
        </Select.Button>
    );
};
const SelectAlbumTags = ({
    idInput,
    options = [],
    placeholder,
    selectedItems = [],
    removeItem = () => {
        /** */
    },
    addItem = () => {
        /** */
    },
    activeActionTags = true,
    buttonStyle = 'grayBackground'
}) => {
    return (
        <>
            <SelectFilter
                idInput={idInput}
                button={<ButtonSelectItems style={buttonStyle} placeholder={placeholder} />}
                selected={null}
                noBorder
                setSelected={addItem}
                required={true}
                error={false}
                options={options}
            />
            {activeActionTags && selectedItems?.length > 0 ? (
                <ul className="mt-3 flex flex-wrap gap-2">
                    {selectedItems.map((item, index) => {
                        return (
                            <li key={index}>
                                <ActionTag data-testid="input-action-tag">
                                    <Icon
                                        icon={item?.type === 'hashtag' ? 'hashtag' : 'labels'}
                                        className="p-1 align-bottom"
                                    />
                                    <span className="mr-1">{item.value}</span>
                                    <button
                                        id={item.id}
                                        aria-label="input-action-tag-delete"
                                        className="leading-none"
                                        onClick={() => removeItem(item)}>
                                        <Icon icon="close" className="align-bottom" />
                                    </button>
                                </ActionTag>
                            </li>
                        );
                    })}
                </ul>
            ) : null}
        </>
    );
};

export default SelectAlbumTags;
